import { FaUsers, FaUserShield, FaUser, FaUserPlus } from 'react-icons/fa';

const CARDS = [
  { key: 'totalUsers', label: 'Total Users', Icon: FaUsers, accent: 'text-stanford-red', chip: 'bg-stanford-red/10' },
  { key: 'totalAdmins', label: 'Admins', Icon: FaUserShield, accent: 'text-blue-600', chip: 'bg-blue-50' },
  { key: 'regularUsers', label: 'Regular Users', Icon: FaUser, accent: 'text-gray-600', chip: 'bg-gray-100' },
  { key: 'recentUsers', label: 'New This Week', Icon: FaUserPlus, accent: 'text-emerald-600', chip: 'bg-emerald-50' },
];

const StatsCards = ({ stats, loading }) => {
  if (loading) {
    return (
      <div className="grid grid-cols-2 md:grid-cols-4 gap-4 mb-6">
        {CARDS.map(({ key }) => (
          <div key={key} className="bg-white rounded-xl border border-gray-100 shadow-sm p-5 flex items-center gap-4">
            <div className="w-11 h-11 rounded-lg bg-gray-100 animate-pulse" />
            <div className="flex-1">
              <div className="h-6 w-10 bg-gray-100 rounded animate-pulse" />
              <div className="h-3 w-20 bg-gray-100 rounded animate-pulse mt-2" />
            </div>
          </div>
        ))}
      </div>
    );
  }

  if (!stats) return null;

  return (
    <div className="grid grid-cols-2 md:grid-cols-4 gap-4 mb-6">
      {CARDS.map(({ key, label, Icon, accent, chip }) => (
        <div key={key} className="bg-white rounded-xl border border-gray-100 shadow-sm p-5 flex items-center gap-4">
          <div className={`w-11 h-11 rounded-lg ${chip} ${accent} flex items-center justify-center shrink-0`}>
            <Icon className="w-5 h-5" />
          </div>
          <div>
            <div className="text-2xl font-bold text-gray-900 leading-none">{stats[key] ?? 0}</div>
            <div className="text-xs font-medium uppercase tracking-wide text-gray-500 mt-1.5">{label}</div>
          </div>
        </div>
      ))}
    </div>
  );
};

export default StatsCards;
